import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  loadingText: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    marginLeft: theme.spacing(1),
  },
}))
